// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-pages {
  color: var(--color-secondary);
  font-weight: 600;
  width: 30px;
  height: 30px;
}

.icon-pages-smaller {
  font-weight: 600;
  width: 25px;
  height: 25px;
}

.text-data-small,
ion-item p.text-data-small {
  font-size: 0.8rem !important;
  color: var(--color-dark) !important;
  vertical-align: super;
  overflow: visible;
}

.text-data-medium,
ion-item p.text-data-message {
  font-size: 0.9rem !important;
  color: var(--color-dark) !important;
  vertical-align: super;
  overflow: visible;
}

.grid-conteggi {
  font-size: 0.7rem;
}

.cancelGeolocButton {
  height: 20px;
}

.elenco-studenti {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/info-idoneita/info-idoneita.component.scss"],"names":[],"mappings":"AACA;EACI,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAIA;;EAEE,4BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;AADF;;AAIA;;EAEI,4BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,eAAA;EACA,0BAAA;EACA,WAAA;AADJ","sourcesContent":["\n.icon-pages {\n    color: var(--color-secondary);\n    font-weight: 600;\n    width: 30px;\n    height: 30px;\n}\n\n.icon-pages-smaller {\n    font-weight: 600;\n    width: 25px;\n    height: 25px;\n}\n\n\n.text-data-small,\n  ion-item p.text-data-small {\n  font-size: 0.8rem !important;\n  color: var(--color-dark) !important;\n  vertical-align: super;\n  overflow: visible;\n}\n\n.text-data-medium,\n    ion-item p.text-data-message {\n    font-size: 0.9rem !important;\n    color: var(--color-dark) !important;\n    vertical-align: super;\n    overflow: visible;\n}\n\n.grid-conteggi {\n    font-size: 0.7rem;\n}\n\n.cancelGeolocButton {\n    height: 20px;\n}\n\n.elenco-studenti {\n    cursor: pointer; \n    text-decoration: underline;\n    color: blue;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
